import React, { type FC } from "react";
import NiceModal, {
  type NiceModalHocProps,
  useModal
} from "@ebay/nice-modal-react";
import KC_Modal_2 from "../../../designsystem/KC_Modal/KC_Modal_2";
import KC_Heading2 from "../../../designsystem/typography/KC-Heading/KC_Heading2";
import { tt } from "../../../utils/i18n/i18n";

interface QRCodeModalProps {
  dataURL: string;
  realGameURL: string;
}

export const QRCODE_OPTIONS = {
  color: {
    dark: "#000"
  },
  width: 4096,
  margin: 0
};

export const QRCodeModal: FC<QRCodeModalProps & NiceModalHocProps> =
  NiceModal.create<QRCodeModalProps>((props) => {
    const modal = useModal();

    return (
      <KC_Modal_2
        id="preview-qrcode-modal"
        isOpen={modal.visible}
        onClose={modal.hide}
        hideCloseButton={false}
        header={<div className="py-2 px-3"></div>}
      >
        <div className="p-4 d-flex flex-column align-items-center st-gap">
          <>
            <KC_Heading2
              text={tt("qrCodeScanInstruction")}
              className="text-center"
              style={{
                wordWrap: "break-word"
              }}
            />
            {props.realGameURL}
            <img
              className="img-responsive"
              src={props.dataURL}
              style={{
                width: 250,
                height: 250
              }}
            />
          </>
        </div>
      </KC_Modal_2>
    );
  });
